// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client'; // Asegúrate de que sea '/client' para React 18+
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root')); // Esto debe encontrar el div en public/index.html
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);